import { Link } from 'react-router-dom';

export const USER_DETAIL_CHANGE_LOGS_COLUMNS = [
    {
        Header: "Name",
        accessor: "name",
        Cell: ({ row, value }) => { return <Link to={`/users/view/${row.original.id}`}>{value}</Link> },
    },
    {
        Header: "Email",
        accessor: "email"
    },
    {
        Header: "Type",
        accessor: "type"
    },
    {
        Header: "Old Value",
        accessor: "enriched_old_value"
    },
    {
        Header: "New Value",
        accessor: "enriched_new_value"
    },
    {
        Header: "Technical Reason",
        accessor: "technical_reason"
    },
    {
        Header: "Updated By",
        accessor: "updated_by_name"
    },
    {
        Header: "Updated At",
        accessor: "updated_at"
    },
];

